/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypeTextIcon16Light = forwardRef('FileTypeTextIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 5.5a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 0 1H8v4.5a.5.5 0 0 1-1 0V6H5.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3.5A2.5 2.5 0 0 1 5.5 1h3.015a1.5 1.5 0 0 1 1.06.44l2.986 2.984A1.5 1.5 0 0 1 13 5.484V11.5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 3 11.5v-8ZM5.5 2A1.5 1.5 0 0 0 4 3.5v8A1.5 1.5 0 0 0 5.5 13h5a1.5 1.5 0 0 0 1.5-1.5V5.485a.5.5 0 0 0-.146-.354L8.869 2.146A.5.5 0 0 0 8.515 2H5.5Z" })));
});
